import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { Device } from "../Core/Device";
import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { LldpEntry, LldpTable } from "../Core/LldpTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class PortLldpTable extends InfoSet {

	private _bpLldpTable: Dictionary<number, LldpTable>;

	private _chassisIdIpAddress: IpAddress;
	public get ChassisId_IpAddress(): IpAddress {
		return this._chassisIdIpAddress;
	}
	public set ChassisId_IpAddress(value: IpAddress) {
		if (value != null)
			this._chassisId = this._chassisIdIpAddress.toString();
		else
			this._chassisId = '';

		this._chassisIdIpAddress = value;
	}

	public get HasChassisId_IpAddress(): boolean {
		return this._chassisIdIpAddress != null;
	}

	private _chassisIdMacAddress: MacAddress;
	public get ChassisId_MacAddress(): MacAddress {
		return this._chassisIdMacAddress;
	}
	public set ChassisId_MacAddress(value: MacAddress) {
		if (value != null)
			this._chassisId = value.toString();
		else
			this._chassisId = '';

		this._chassisIdMacAddress = value;
	}

	public get HasChassisId_MacAddress():boolean {
		return this._chassisIdMacAddress != null && !this._chassisIdMacAddress.IsNull;
	}

	public ChassisIdSubtype: number;
	private _chassisId: string;
	public get ChassisId():string {
		return this._chassisId;
	}
	public set ChassisId(value:string) {
		this._chassisId = value || '';
	}

	public get HasChassisId():boolean {
		return !!this._chassisId;
	}

	constructor(device: Device ){
		super(device);
		this._bpLldpTable = new Dictionary<number, LldpTable>();

		this._chassisId = '';
		this._chassisIdIpAddress = null;
		this._chassisIdMacAddress = null;
		this.ChassisIdSubtype = -1;
	}

	public Add(timeMark:number, localPortNum:number,index:number): LldpEntry {
		var lldpEntry: LldpEntry = null;

		if (localPortNum >= 0) {
			var lldpTable: LldpTable = this._bpLldpTable.Item(localPortNum);
				
			if(!lldpTable) {
				lldpTable = new LldpTable();
				this._bpLldpTable.Add(localPortNum, lldpTable);
			}

			lldpEntry = lldpTable.Add(timeMark, localPortNum, index);
		}

		return (lldpEntry);
	}

	private AddEntry(lldpEntry: LldpEntry): void {
		if (lldpEntry && lldpEntry.LocalPortNum >= 0) {
			var lldpTable: LldpTable = this._bpLldpTable.Item(lldpEntry.LocalPortNum);

			if (!lldpTable) {
				lldpTable = new LldpTable();
				this._bpLldpTable.Add(lldpEntry.LocalPortNum, lldpTable);
			}

			lldpTable.AddEntry(lldpEntry);
		}
	}

	public Clear():void	{
		this._bpLldpTable.Clear();

		this._chassisId = '';
		this._chassisIdIpAddress = null;
		this._chassisIdMacAddress = null;
	}

	public get Count(): number{
		return this._bpLldpTable.Count;
	}

	public ClearRemoteCache(): void {
		this._bpLldpTable.ForEach((pair) => {
			pair.Value.ClearRemoteCache();
		});
	}

	public get HasMacAddresses():boolean {
		return true;
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		if (this.HasChassisId_MacAddress) {
			macAddresses.Add(this.ChassisId_MacAddress);
		}

		return (macAddresses);
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._bpLldpTable.ForEach((pair) => {
			pair.Value.ForEach((lldpEntry) => {
				if (lldpEntry.HasChassisId_IpAddress)
					ipAddresses.Add(lldpEntry.ChassisId_IpAddress);
			});
		});

		return (ipAddresses);
	}

	public ForEach(callbackfn: (value: LldpTable, index: number, array: LldpTable[]) => void, thisArg?: any): void {
		this._bpLldpTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: LldpTable, index: number, array: LldpTable[]) => boolean, thisArg?: any): boolean {
		return this._bpLldpTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: LldpTable, index: number, array: LldpTable[]) => boolean, thisArg?: any): boolean {
		return this._bpLldpTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.port_lldp_info = {};
		obj = obj.port_lldp_info;

		if (this.HasChassisId) {
			obj.chassis_id_subtype = ValueEncoder.EncodeInteger(this.ChassisIdSubtype);

			obj.chassis_id = this.ChassisId;

			if (this.HasChassisId_IpAddress)
				obj.chassis_id_ip_address = ValueEncoder.EncodeIpAddress(this.ChassisId_IpAddress);

			if (this.HasChassisId_MacAddress)
				obj.chassis_id_mac_address = ValueEncoder.EncodeMacAddress(this.ChassisId_MacAddress);
		}

		if (this._bpLldpTable.Count > 0) {
			obj.lldp_table = [];
			this._bpLldpTable.Values().ForEach((lldpTable: LldpTable) => {
				lldpTable.ForEach((lldpEntry: LldpEntry) => {
					let elem: any = {
						lldp_entry: {
							time_mark: ValueEncoder.EncodeInteger(lldpEntry.TimeMark),
							local_port_num: ValueEncoder.EncodeInteger(lldpEntry.LocalPortNum),
							index: ValueEncoder.EncodeInteger(lldpEntry.Index)
						}
					};

					if (lldpEntry.HasChassisId) {
						elem.lldp_entry.chassis_id_subtype = ValueEncoder.EncodeInteger(lldpEntry.ChassisIdSubtype);
						elem.lldp_entry.chassis_id = lldpEntry.ChassisId;
					}

					if (lldpEntry.HasPortId) {
						elem.lldp_entry.port_id_subtype = ValueEncoder.EncodeInteger(lldpEntry.PortIdSubtype);
						elem.lldp_entry.port_id = lldpEntry.PortId;
					}

					if (lldpEntry.HasPortDesc)
						elem.lldp_entry.port_description = lldpEntry.PortDesc;

					if (lldpEntry.HasSysName)
						elem.lldp_entry.system_name = lldpEntry.SysName;

					if (lldpEntry.HasSysDesc)
						elem.lldp_entry.system_description = lldpEntry.SysDesc;

					obj.lldp_table.push(elem);
				}, this);
			}, this);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.port_lldp_info)
			throw new Error();
		obj = obj.port_lldp_info;

		this.Clear();

		if (obj.chassis_id_subtype !== undefined)
			this.ChassisIdSubtype = ValueEncoder.DecodeInteger(obj.chassis_id_subtype);

		if (obj.chassis_id !== undefined)
			this.ChassisId = obj.chassis_id;

		if (obj.chassis_id_ip_address !== undefined)
			this.ChassisId_IpAddress = ValueEncoder.DecodeIpAddress(obj.chassis_id_ip_address);

		if (obj.chassis_id_mac_address)
			this.ChassisId_MacAddress = ValueEncoder.DecodeMacAddress(obj.chassis_id_mac_address);

		if (obj.lldp_table !== undefined) {
			obj.lldp_table.forEach((elem: any) => {
				if (!elem.lldp_entry)
					throw new Error();
				elem = elem.lldp_entry;

				let lldpEntry = new LldpEntry();

				if (elem.time_mark !== undefined)
					lldpEntry.TimeMark = ValueEncoder.DecodeInteger(elem.time_mark);

				if (elem.local_port_num !== undefined)
					lldpEntry.LocalPortNum = ValueEncoder.DecodeInteger(elem.local_port_num);

				if (elem.index !== undefined)
					lldpEntry.Index = ValueEncoder.DecodeInteger(elem.index);

				if (elem.chassis_id_subtype !== undefined)
					lldpEntry.ChassisIdSubtype = ValueEncoder.DecodeInteger(elem.chassis_id_subtype);

				if (elem.chassis_id !== undefined)
					lldpEntry.ChassisId = elem.chassis_id;

				if (elem.port_id_subtype !== undefined)
					lldpEntry.PortIdSubtype = ValueEncoder.DecodeInteger(elem.port_id_subtype);

				if (elem.port_id !== undefined)
					lldpEntry.PortId = elem.port_id;

				if (elem.port_description !== undefined)
					lldpEntry.PortDesc = elem.port_description;

				if (elem.system_name !== undefined)
					lldpEntry.SysName = elem.system_name;

				if (elem.system_description !== undefined)
					lldpEntry.SysDesc = elem.system_description;

				this.AddEntry(lldpEntry);
			}, this);
		}
	}

}
